module.exports = __webpack_public_path__ + "img/jana.31bc4782.jpeg";